// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/errors/smtp-options',
    requestBody: null,
    response: '{"options":"SmtpConfig[]"}'
  },
  {
    method: 'GET',
    endpoint: '/api/errors/config',
    requestBody: null,
    response: '{"emailTo":"string","smtpConfigId":"number","throttleMinutes":"number"}'
  },
  {
    method: 'GET',
    endpoint: '/api/errors/recent',
    requestBody: null,
    response: '{"errors":"ErrorLog[]"}'
  },
  {
    method: 'POST',
    endpoint: '/api/errors/config',
    requestBody: '{"emailTo":"string","smtpConfigId":"number","throttleMinutes":"number"}',
    response: '{"ok":"true"}'
  },
  {
    method: 'POST',
    endpoint: '/api/errors/test-email',
    requestBody: '{"email":"string"}',
    response: '{"ok":"true"}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
